import React from 'react'
import { Input, Card } from 'antd'
import { useFormikContext } from 'formik'
import { FormField, FormGrid } from './shared'
import { useFieldPath } from './TabContext'
import { get } from 'lodash'

const { TextArea } = Input

export const AboutContentSection: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>()

  const modulesPath = useFieldPath('sections.aboutContent.metrics.modules')
  const lessonsPath = useFieldPath('sections.aboutContent.metrics.lessons')
  const minDaysPath = useFieldPath('sections.aboutContent.metrics.minDays')
  const maxDaysPath = useFieldPath('sections.aboutContent.metrics.maxDays')
  const certificationTextPath = useFieldPath('sections.aboutContent.certificationText')
  const validityTextPath = useFieldPath('sections.aboutContent.validityText')

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFieldValue(e.target.name, e.target.value)
  }

  return (
    <Card>
      <h4>Métricas do Curso</h4>
      <FormGrid>
        <FormField>
          <label>Número de Módulos</label>
          <Input
            name={modulesPath}
            type="number"
            value={get(values, modulesPath, '')}
            onChange={handleChange}
            placeholder="Ex: 4"
          />
        </FormField>
        <FormField>
          <label>Número de Aulas</label>
          <Input
            name={lessonsPath}
            type="number"
            value={get(values, lessonsPath, '')}
            onChange={handleChange}
            placeholder="Ex: 36"
          />
        </FormField>
        <FormField>
          <label>Dias Mínimos</label>
          <Input
            name={minDaysPath}
            type="number"
            value={get(values, minDaysPath, '')}
            onChange={handleChange}
            placeholder="Ex: 7"
          />
        </FormField>
        <FormField>
          <label>Dias Máximos</label>
          <Input
            name={maxDaysPath}
            type="number"
            value={get(values, maxDaysPath, '')}
            onChange={handleChange}
            placeholder="Ex: 90"
          />
        </FormField>
      </FormGrid>

      <FormField>
        <label>Texto de Certificação</label>
        <Input
          name={certificationTextPath}
          value={get(values, certificationTextPath, '')}
          onChange={handleChange}
          placeholder="Ex: Válida DETRAN e SENATRAN"
        />
      </FormField>

      <FormField>
        <label>Texto de Validade</label>
        <Input
          name={validityTextPath}
          value={get(values, validityTextPath, '')}
          onChange={handleChange}
          placeholder="Ex: 5 anos em todo o Brasil"
        />
      </FormField>
    </Card>
  )
}
